<script>
	export default {
		props: ['item']
	};
</script>
<template>
	<li>
		<outbound-link
			v-if="item.outbound"
			:href="item.href"
			:target="item.target"
			:data-outbound-link="item.name"
			:data-text="item.label"
			>{{ item.label }}</outbound-link
		>
		<a
			v-if="!item.outbound"
			:data-text="item.label"
			:href="item.href">
			{{ item.label }}
		</a>
		<slot></slot>
	</li>
</template>
